import React, { useState, useEffect } from "react";
import { Routes, Route, Outlet, useLocation, HashRouter } from "react-router-dom";
import Home from "./pages/home";
import { ResultPage } from "./pages/result";
import ProductDetailPage from "./pages/details";
import { Header } from "./pages/components/header";
import LoginPage from "./pages/login";
import CartPage from "./pages/cart";
import { ProfilePage } from "./pages/profile";
import DocumentsPage from "./pages/documents";
import { OrderStatusPage } from "./pages/orderStatus";

const Layout: React.FC = () => {
  const location = useLocation();

  const isLoginPage = location.pathname === "/login";

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {!isLoginPage && <Header />}
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
    </div>
  );
};
export default function App() {
  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/details" element={<ProductDetailPage />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/documents" element={<DocumentsPage />} />
                    <Route path="/login" element={<LoginPage />} />
  <Route path="/orderStatus" element={<OrderStatusPage />} />
        </Route>
      </Routes>
    </>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "flex-end",
    zIndex: 2000,
    transition: "opacity 0.3s ease",
  },
  drawer: {
    width: "20%",
    minWidth: 280,
    backgroundColor: "#fff",
    height: "100%",
    padding: 20,
    boxShadow: "-2px 0 8px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease-in-out",
    transform: "translateX(100%)",
  },
};
